import { getMarketplace } from 'reducers/marketplace/MarketplaceSelectors';
import { createSelector } from 'reselect';
import { RootState } from 'store';
import { Option } from 'types/Generics';
import { PetTypeId } from 'types/Pet';

export const getMasterDataState = (state: RootState) => state.masterData;

export const getMasterData = createSelector(
    (state: RootState) => state.masterData,
    masterData => masterData.data
);

export const getOlbDateLimits = createSelector([getMasterData], masterData => {
    return {
        from: masterData.olbFromLimits,
        to: masterData.olbToLimits
    };
});

export const getPetGenders = createSelector([getMasterData], masterData => {
    return masterData.petGenders;
});

export const getPetBreeds = createSelector(
    [getMasterData, (state, petType: PetTypeId) => petType],
    (masterData, petType) => {
        return masterData.petBreeds
            .filter(breed => breed.filter === petType)
            .filter(breed => breed.id !== 0);
    }
);

export const getPetHairColors = createSelector(
    [getMasterData, (state, petType: PetTypeId) => petType],
    (masterData, petType) => {
        return masterData.petHairColors.filter(hairColor => hairColor.filter === petType);
    }
);

export const getPetTypes = createSelector([getMasterData], masterData => {
    return masterData.petTypes;
});

export const getPetTypesOptions = createSelector(
    [getMarketplace, getMasterData],
    (marketplace, masterData): Array<Option<string>> => {
        return masterData.petTypes
            .filter(type => marketplace.petTypes[type.id].enabled)
            .map(type => ({
                id: type.id,
                name: type.singular
            }));
    }
);
